import React from 'react';
import AMPPage from '../AMPPage';
import AMPPageHeader from '../AMPPageHeader';
import AMPPageSection from '../AMPPageSection';

export default function MonetizationTermsPage() {
  return (
    <AMPPage>
      <AMPPageHeader
        title="Anchor FM Inc."
        subtitle="Monetization Terms of Service"
      />
      <AMPPageSection>
        <p>Date of Last Revision: December 3, 2018</p>
        <p>
          Anchor’s products and services are provided by Anchor FM Inc.
          (“Anchor”, “us”, “we” or “our”). These Monetization Terms of Service
          (the “Agreement”) govern your access to and use of Anchor’s
          monetization services, including Anchor Listener Support, Anchor
          Sponsorships, and any other services that enable you to collect money
          through your usage of Anchor (collectively, the “Monetization
          Services”). By accessing or using the Monetization Services in any
          manner, you agree to abide by this Agreement and all other operating
          rules, policies and procedures that may be published from time to time
          to the Monetization Services by us, each of which is incorporated by
          reference and each of which may be updated from time to time without
          notice to you. You acknowledge and agree that this Agreement is hereby
          incorporated by reference into our Terms of Service available at
          https://anchor.fm/tos (“Terms of Service”), which governs your use of
          any Anchor products or services.
        </p>
        <p>
          We reserve the right, in our sole discretion, to modify or replace any
          of this Agreement, or change, suspend, or discontinue the Monetization
          Services (including without limitation, the availability of any
          feature, database, or content) at any time by posting a notice through
          the Monetization Services, via e-mail or by another appropriate means
          of electronic communication. We may also impose limits on certain
          features and services or restrict your access to parts or all of the
          Monetization Services without notice or liability. Your continued use
          of the Monetization Services following any changes to this Agreement
          constitutes acceptance of those changes, which will apply to your
          continued use of the Monetization Services going forward. Your use of
          the Monetization Services is subject to the Agreement in effect at the
          time of such use.
        </p>
        <h3>1. Monetization Services.</h3>
        <h4>1.1 Monetization Services.</h4>
        <p>
          Subject to the terms and conditions of this Agreement, Anchor will
          provide or make available the Monetization Services on its website,
          mobile application and related products and services (the “Service”).
          In addition, Anchor will provide you with tools to help you develop,
          launch, operate and market your User Content (as defined in our Terms
          of Service) for the purposes of monetizing (whereby your User Content
          will become “Monetized Content”). You agree to only use the
          Monetization Services if you are located within the United States of
          America.
        </p>
        <h4>1.2 Registration.</h4>
        <p>
          As a condition to using the Service and Monetization Services, you may
          be required to register an account with Anchor, select a password and
          user name and provide other information about your identity, company
          or investments (“Registration Data”). You agree to (a) provide
          accurate, current and complete Registration Data; (b) maintain the
          security of your password and user name; (c) maintain and promptly
          update the Registration Data, and any other information you provide to
          Anchor, to keep it accurate, current and complete; and (d) be fully
          responsible for all use of your account and for any actions that take
          place using your account. You agree to receive all required notices
          electronically, including through the Services (such as by displaying
          links to notices generally in the Services) or to the provided e-mail
          address. It is your responsibility to update or change that e-mail
          address, as appropriate. If you become aware of any unauthorized use
          of your Registration Data for the Services, you agree to notify Anchor
          immediately. Anchor may identify you as an Anchor customer (using your
          name and logo) and generally describe the products or services it
          provides to you in its promotional materials, presentations and
          proposals to other current and prospective customers.
        </p>
        <h4>1.3 Ownership; License Grant.</h4>
        <p>
          Subject to the terms and conditions of this Agreement, Anchor hereby
          grants to you, during the Term, a non-exclusive, non-transferable
          right to access and use the Monetization Services solely for the
          purpose of monetizing your User Content. Except for the rights
          expressly granted herein, Anchor reserves all right, title and
          interest in and to the Monetization Services other than your Monetized
          Content, which shall be owned by you in accordance with our Terms of
          Service. The foregoing license does not include any collection,
          aggregation, copying, duplication, scraping, display or derivative use
          of the Service or Monetization Services, nor any use of data mining,
          crawlers, robots, spiders, or similar data gathering and extraction
          tools for any purpose unless expressly permitted by Anchor in writing.
          A limited exception is provided to general purpose internet search
          engines and non-commercial public archives that use such tools to
          gather information for the sole purpose of displaying hyperlinks to
          the Service. All rights in and to the Service and Monetization
          Services are retained by Anchor, except for those expressly granted
          herein.
        </p>
        <h4>1.4 Restrictions.</h4>
        <p>
          Except as expressly permitted hereunder, you will not authorize any
          third party to: (a) copy, modify, reverse engineer, decompile,
          disassemble or otherwise attempt to discover the source code, object
          code or underlying structure, ideas or algorithms of any of the
          Monetization Services; (b) translate or create derivative works based
          on any of the Monetization Services; (c) license, sublicense, sell,
          resell, rent, lease, transfer, assign, distribute, time share, or
          otherwise commercially exploit or make the Monetization Services
          available to any third party; (d) remove or obscure any proprietary
          notices or labels of Anchor or its suppliers on any of the
          Monetization Services or (e) access or use the Monetization Services
          (or any part thereof) to build a competitive product or service.
        </p>
        <h4>1.5 Feedback.</h4>
        <p>
          You may from time to time provide suggestions, comments for
          enhancements or functionality or other feedback (“Feedback”) to Anchor
          with respect to the Monetization Services. Anchor may or may not to
          proceed with the development of the Feedback. You hereby grant Anchor
          a royalty-free, fully paid up, worldwide, transferable,
          sublicenseable, irrevocable, perpetual license to (a) copy,
          distribute, display, perform, and create derivative works of the
          Feedback and (b) use the Feedback and/or any subject matter thereof,
          including without limitation, the right to develop, manufacture, have
          manufactured, market, promote, sell, have sold, offer for sale, have
          offered for sale, import, have imported, rent, provide and/or lease
          products or services which practice or embody, or are configured for
          use in practicing, the Feedback and/or any subject matter of the
          Feedback.
        </p>
        <h3>2. Fees and Payment.</h3>
        <h4>2.1 General.</h4>
        <p>
          You will pay to Anchor such percentage of any revenue you receive
          using the Service, in accordance with the applicable fees (“Fee
          Schedule”) generally applied to all of Anchor’s users. Variations or
          changes to the Fee Schedule as they pertain to your usage of the
          Monetization Services may be agreed upon from time to time with Anchor
          in writing. Anchor reserves the right to charge you a portion of any
          costs of any chargeback or credit card fees or mobile platform fees
          that Anchor incurs in connection with its management of your Monetized
          Content or your usage of the Monetization Services. Without limiting
          anything herein to the contrary, Anchor also reserves the right to
          change the Fee Schedule from time to time, with reasonable prior
          notice to you in writing. Revenue collected by from sponsors of your
          Monetization Content, including but not limited to Anchor (“Sponsors”)
          will be paid to you in accordance with the Fee Schedule relating to
          payments from Sponsors. Fees may be withdrawn from revenue prior to it
          becoming available to you. The ability to withdraw revenue may be
          delayed before it becomes available to you.
        </p>
        <h4>2.2 Net of Taxes.</h4>
        <p>
          All amounts payable hereunder are exclusive of any sales, use and
          other taxes or duties, however designated, that may be applicable to
          such amounts payable, (collectively, but excluding any taxes based
          solely on the income of either Party (“Taxes”)). You will be solely
          responsible for payment of any sales, use, duty or value-added Tax due
          in relation to any of your transactions with Anchor and Anchor may add
          the amount of such Tax to any invoice to you or, if applicable,
          withhold such Tax from any payment to you.
        </p>
        <h4>2.3 Suspension; Refunds.</h4>
        <p>
          If Anchor believes you are abusing the Monetization Services in any
          way, or are being negligent in your communication with users who pay
          you (“Payers”), or believes that you are being negligent with your
          upkeep of the Monetized Content, Anchor may, in its sole discretion
          and without limiting other remedies, limit, suspend, or terminate your
          user account(s) and access to the Monetization Services, delay or
          remove hosted content, remove any special status associated with your
          account(s), remove, not display, and/or demote listings, reduce or
          eliminate any discounts, and take technical and/or legal steps to
          prevent you from using the Anchor Services. Anchor reserves the right
          to, in its sole discretion, refund subscription fees paid by
          subscribers to your Monetized Content or to your account, and/or
          payments paid by Sponsors fo your Monetization Content, in which case
          you shall refund Anchor for such refund payments. To the extent that
          you fail to refund such payments to Anchor, you hereby agree that
          Anchor may offset such refund payments against subsequent payments
          required to be made to you by Payers through the Monetization
          Services.
        </p>

        <h3>3. Responsibilities.</h3>
        <h4>3.1 Responsibility.</h4>
        <p>
          You are solely responsible for your Monetization Content and your
          usage of the Monetization Services and compliance with any laws or
          regulations related to them, including without limitation, the
          following:
        </p>
        <p>
          a) You are solely responsible for any claims or warranties you make in
          connection with the Monetization Services and any claims made by other
          users against you as they relate to the Monetization Content or your
          usage of the Monetization Services;
        </p>
        <p>
          b) You are solely responsible for handling any comments or complaints
          related to your usage of the Monetization Services, including without
          limitation any issues related to payments, promotions, refunds or
          chargebacks. You agree to provide accurate and complete contact
          information to Payers so that they can submit comments or complaints;{' '}
        </p>
        <p>
          c) You shall comply with any consumer, securities and related laws and
          regulations.
        </p>
        <p>
          d) You are solely responsible for any claims arising out of your
          disparagement of Sponsors in your Monetization Content.
        </p>

        <h4>3.2 Obligations to Sponsors.</h4>
        <p>
          Certain Sponsors may have additional requirements or obligations for
          you to fulfill in connection with your creation, production or
          distribution of your Monetization Content, including but not limited
          to attribution or promotional obligations (“Sponsor Requirements”).
          You agree to comply with these Sponsor Requirements to the reasonable
          satisfaction of your Sponsors.
        </p>
        <p>
          You are in no way precluded from monetizing your User Content in ways
          other than the usage of the Monetization Services. However, in certain
          instances, Sponsors of your show may request that they be sole
          sponsors of your User Content, or sole sponsors within a particular
          brand category of your User Content (“Exclusivity”). In such instances
          where you agree to monetize your User Content through these Sponsors,
          you will not be able to monetize your User Content, including outside
          of the Monetization Services, in a manner that violates the Brand
          Exclusivity.
        </p>
        <p>
          If you do monetize your User Content outside of the Monetization
          Services, please note that you are still responsible for using
          Anchor’s Services in a way that complies with our standard Terms of
          Service,
        </p>

        <h3>4. No Obligation to Examining Content.</h3>
        <p>
          You acknowledge and agree that Anchor is not responsible for examining
          or warranting the Monetized Content (each as defined below) or other
          third parties through the Monetization Services, and you will not
          attempt to hold Anchor or Anchor’ data providers liable for
          inaccuracies. You shall ensure that content directly associated with
          your usage of the Monetization Services is accurate. While Anchor has
          no obligation to monitor any User Content, you acknowledge and agree
          that Anchor may revise, modify, obfuscate or delete data or content
          associated with the Monetized Content to supplement, remove or correct
          information, in its sole discretion, as well as provide you with
          optional recommendations to consider when creating and operating the
          Monetized Content.
        </p>

        <h3>5. Community Guidelines.</h3>
        <p>
          Anchor has a set of community guidelines that further govern the
          conduct of all users of the Service. You will comply with such
          guidelines incorporated herein by reference.
        </p>

        <h3>6. Disclosure of Monetized Content.</h3>
        <p>
          ANCHOR ALSO RESERVES THE RIGHT, AT ALL TIMES AND IN ITS SOLE
          DISCRETION, TO DISCLOSE ANY CONTENT, MATERIALS AND OTHER RELATED
          INFORMATION FOR ANY REASON, including without limitation (a) to
          satisfy any applicable law, regulation, legal process or governmental
          request; (b) to enforce the terms of the Agreement; (c) to protect
          Anchor’ legal rights and remedies; (d) if Anchor, in its reasonable
          discretion, believe that someone’s health or safety may be threatened;
          or (e) to report a crime or other offensive behavior.
        </p>

        <h3>7. Data.</h3>
        <p>
          You own the electronic data or information submitted by you in
          connection with accessing and using the Monetization Services,
          excluding (a) data and information relating to the operation and/or
          performance of the Monetization Services and (b) any information that
          another user expressly submits to Anchor in connection with such user
          interacting with a Anchor product or service (“Monetization Services
          Data”). You hereby grant to Anchor (a) a non-exclusive, worldwide,
          royalty-free, fully paid up, sublicensable, right and license to copy,
          distribute, display and create derivative works of and use this
          Monetization Services data to perform Anchor’s obligations under this
          Agreement, (b) a non-exclusive, perpetual, irrevocable, worldwide,
          royalty-free, fully paid up, sublicensable right and license to copy,
          distribute, display and create derivative works of and otherwise use
          the Monetization Services Data (i) in connection with internal
          operations and functions, including, but not limited to, operational
          analytics and reporting, internal financial reporting and analysis,
          audit functions and archival purposes and (ii) to the extent that such
          data is aggregated and anonymized (i.e. no personally identifiable
          information including, without limitation, name, age, phone number and
          email address and no identification of the specific source of such
          data) (the “Anonymous Monetization Services Data”) for marketing and
          other related purposes.{' '}
          <strong>
            Note that the preceding paragraph applies to Monetization Services
            data, NOT to your rights in the User Content itself.
          </strong>
        </p>

        <h3>8. Confidentiality.</h3>
        <p>
          As used herein, “Confidential Information” means, any and all
          information, regardless of whether it is in tangible form, disclosed
          by a Party (the “Disclosing Party”) to the other Party (the “Receiving
          Party”) that is either (a) marked as confidential or proprietary, (b)
          identified in writing as confidential or proprietary within thirty
          (30) days of disclosure, or (c) would be apparent to a reasonable
          person, familiar with Disclosing Party’s business and the industry in
          which each operates, to be of a confidential or proprietary nature the
          maintenance of which is important to the Disclosing Party. Information
          will not be deemed Confidential Information if such information: (i)
          was available to or in its possession prior to receipt from the
          Disclosing Party directly or indirectly from a source other than one
          having an obligation of confidentiality to the Disclosing Party; (ii)
          becomes known (independently of disclosure by the Disclosing Party) to
          the Receiving Party directly or indirectly from a source other than
          one having an obligation of confidentiality to the Disclosing Party or
          (iii) becomes publicly known or otherwise ceases to be secret or
          confidential, except through a breach of this Agreement by the
          Receiving Party. The Receiving Party will only use the Disclosing
          Party’s Confidential Information to exercise its rights or perform its
          obligations under this Agreement. Each Receiving Party will use
          reasonable measures to protect the secrecy of and avoid disclosure and
          unauthorized use or reproduction of the other Party’s Confidential
          Information. Confidential Information of the Disclosing Party may be
          disclosed by the Receiving Party only to such employees and agents of
          the Receiving Party as may have a need to know such information in the
          course of their duties, provided, that, in each case, such recipients
          are bound by written confidentiality obligations at least as
          restrictive as those set forth herein. Confidential Information of the
          Disclosing Party may also be disclosed by the Receiving Party if
          required by law or valid order of a court or other governmental
          authority (provided that the Receiving Party delivers reasonable
          notice to the Disclosing Party and uses commercially reasonable
          efforts to cooperate with Disclosing Party’s attempt to obtain a
          protective order). Upon the written request of the Disclosing Party,
          the Receiving Party agrees to promptly return or destroy all
          Confidential Information, including all copies thereof in its
          possession (certifying the fact of such destruction to the Disclosing
          Party), with the exception that the Receiving Party (a) may retain an
          archival copy of the Confidential Information and (b) is not required
          to destroy or alter computer-based back-up files generated in the
          normal course of its business. Any Confidential Information contained
          in such archival copies or back-up files shall, however, remain
          subject to the confidentiality obligations of this Section 4.
        </p>

        <h3>9. Termination.</h3>
        <p>
          You may stop using the Monetization Services at any time, in which
          case certain agreements in this Monetization Terms of Service may
          terminate or no longer apply to you. However, all provisions of this
          Agreement which by their nature should survive termination shall
          survive termination, including, without limitation, limitations of
          liability, fees, and refunds.
        </p>

        <h3>10. Limitation of Liability.</h3>
        <p>
          TO THE EXTENT PERMITTED BY LAW, ANCHOR IS NOT LIABLE TO YOU FOR ANY
          DAMAGES ARISING OUT OF THESE TERMS OR YOUR USAGE OF THE MONETIZATION
          SERVICES (WHETHER INCIDENTAL, CONSEQUENTIAL OR PUNITIVE). TO THE
          EXTENT PERMITTED BY LAW, OUR LIABILITY FOR ANY DAMAGES IS LIMITED TO
          DIRECT DAMAGES WHICH IN NOT EVENT WILL EXCEED THE MONEY RECEIVED BY
          YOU THROUGH THE MONETIZATION SERVICES WITHIN THE TWELVE MONTHS
          IMMEDIATELY PRECEDING THE CLAIM FOR DAMAGES. YOU AGREE THAT IN NO
          INSTANCE WILL ANCHOR BE LIABLE FOR LOSSES CAUSED BY CONTRACTUAL
          AGREEMENTS THAT CONFLICT WITH THESE TERMS. ANY LIMITATION OF ANCHOR’S
          LIABILITY WITH RESPECT TO LIABILITY ARISING FROM ANY NEGLIGENCE, GROSS
          NEGLIGENCE OR INTENTIONAL MISCONDUCT IS NOT ENFORCEABLE WITH RESPECT
          TO VISITORS OF THE SITE FROM NEW JERSEY.
        </p>
        <p>
          SOME JURISDICTIONS DO NOT ALLOW THE LIMITATION OR EXCLUSION OF
          LIABILITY FOR NEGLIGENCE, INCIDENTAL OR CONSEQUENTIAL DAMAGES.
          ACCORDINGLY, SUCH DISCLAIMERS, EXCLUSIONS, LIMITATIONS OR CONTRACTUAL
          INDEMNIFICATION PROVISIONS MAY NOT BE ENFORCEABLE ON VISITORS FROM ANY
          SUCH JURISDICTION.
        </p>
      </AMPPageSection>
    </AMPPage>
  );
}
